import cx from "classnames";

import styles from "../../styles/Box.module.less";

type BoxProps = {
  children: React.ReactNode;
  className?: string;
  outline?: boolean;
};

const Box = ({ children, className = "", outline = true }: BoxProps) => {
  return <div className={cx(className, styles.box, outline && styles.outline)}>{children}</div>;
};

export default Box;
